import { Component, Prop, Vue } from "vue-property-decorator";
import { FilterTemplate } from "@/models/Filter";

@Component
export default class ProductFilter extends Vue {
  @Prop() private disabled!: boolean;
  @Prop() private filter!: FilterTemplate;
}
